module.exports = __webpack_public_path__ + "img/complex-simulation-icon-svg.5d6ef562.svg";